import React from 'react'

const Home = () => {
  return (
    <div className='flex  text-6xl font-semibold text-red-300 h-full'><div className='m-auto '> Home Page is Under Construction.</div></div>
  )
}

export default Home